import React from "react";

const SaveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="17px"
    viewBox="0 0 24 24"
    style={{ margin: "0px 3px -2px 3px" }}
    viewBox="0 0 24 24"
    fill="#fff"
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41l-2.82-2.83zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm1-10H7c-1.1 0-2-.9-2-2s.9-2 2-2h6c1.1 0 2 .9 2 2s-.9 2-2 2z" />
  </svg>
);

export default SaveIcon;
